import { render } from "./RecetasCard.vue?vue&type=template&id=714e1c2e&scoped=true&ts=true"
import script from "./RecetasCard.vue?vue&type=script&lang=ts"
export * from "./RecetasCard.vue?vue&type=script&lang=ts"

import "./RecetasCard.vue?vue&type=style&index=0&id=714e1c2e&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714e1c2e"]])

export default __exports__